let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1crCS")).then(() => parcelRequire('ev8xC'));